import { Controller } from "@hotwired/stimulus"

// landing v2 — มือถือจำลองบน hero: สลับหน้าจอ (แชท LINE → หน้าจริงในแอป) ทีละหน้าแบบจางเข้า
// เลื่อนเองทุก autoValue ms · กดป้ายชื่อหน้า = ไปหน้านั้นและหยุดเลื่อนเองถาวร
// ผู้ใช้ตั้งลดการเคลื่อนไหว = ไม่เลื่อนเอง · แท็บซ่อนอยู่ = ไม่นับรอบ
// ภาพหน้าจอแอปมาเป็น data-src — โหลดเฉพาะหน้าถัดไปหลังหน้าเว็บโหลดเสร็จ ไม่แย่งแบนด์วิดท์จอแรก
export default class extends Controller {
  static targets = ["slide", "tab"]
  static values = { auto: Number }

  connect() {
    this.index = 0
    if (document.readyState === "complete") this.preload(1)
    else window.addEventListener("load", () => this.preload(1), { once: true })
    if (this.autoValue && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.timer = setInterval(() => {
        if (!document.hidden) this.show((this.index + 1) % this.slideTargets.length)
      }, this.autoValue)
    }
  }

  disconnect() {
    clearInterval(this.timer)
  }

  pick({ params: { index } }) {
    clearInterval(this.timer)
    this.show(index)
  }

  // ใส่ src ให้ภาพของสไลด์ที่ i (ถ้ายังไม่มี)
  preload(i) {
    const img = this.slideTargets[i]?.querySelector("img[data-src]")
    if (img) {
      img.src = img.dataset.src
      img.removeAttribute("data-src")
    }
  }

  show(i) {
    this.preload(i)
    this.preload((i + 1) % this.slideTargets.length)
    this.index = i
    this.slideTargets.forEach((s, j) => s.classList.toggle("on", j === i))
    this.tabTargets.forEach((t, j) => {
      t.classList.toggle("on", j === i)
      t.setAttribute("aria-pressed", j === i)
    })
  }
}
